import PreeFooter from './Prefooter';

export default PreeFooter;